import { URLS } from '../../config/api-config';
import { WindowType } from '../../types/global-window-type';

declare const window: WindowType;

export interface IUserInfo {
  firstName: string;
  lastName: string;
  email: string;
  userToken: string;
  isLoggedIn: boolean;
}
const accountId = 'ozoDdrmewShEcbUDWX8J3V';

const getUserData = async (): Promise<IUserInfo | undefined> => {
  try {
    let token = '';
    if (
      window.vp &&
      window.vp.auth &&
      window.vp.auth.cache &&
      window.vp.auth.cache.accessToken &&
      window.vp.auth.cache.isSignedIn
    ) {
      token = window.vp.auth.cache.accessToken;
      const url = URLS.API_ENDPOINTS.PROFILE(accountId);
      const response = await fetch(url, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      // check response ok key is true or false
      if (response.ok) {
        const user = await response.json();
        return {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          userToken: token,
          isLoggedIn: !!user.email,
        };
      }
    }
  } catch (err) {
    const error = err as Error;
    console.info('Error in User Authentication', { errorMessage: error.message, errorStack: error.stack });
    return undefined;
  }
  return undefined;
};

export { getUserData };
